import React from "react";
import "./tweet.css";
import TweetEmbed from "react-tweet-embed";
import "./comingstories.css";

function ComingStories() {
  return (
    <div
      style={{ padding: "0.3rem", backgroundColor: "#fdfd97" }}
      id="story"
      className="stories"
    >
      <h1 style={{ margin: "2rem 0", textAlign: "center" }}>
        Coming Out Stories
      </h1>
      <div style={{ display: "flex", margin: "2rem 0" }}>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
            marginRight: "2rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/2.1.jpg"}></img>
          <div>
            <h5 style={{ color: "whitesmoke" }}>
              <br />"Sharing mycomingoutstory is something I have been wanted to do.
              I am so thankful and blessed to have support and loving friends,
              family, & parents."
            </h5>
            {/* <h6 style={{ marginLeft: "20rem", color: "whitesmoke" }}>
              ~ Brian Kiely
            </h6> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/2.2.jpg"}></img>
          <div style={{ margin: "2rem 0" }}>
            <h5 style={{ color: "whitesmoke" }}>
              Me: mom I like girls, too <br />Mom: *without even looking at me* I know <br />
              Me: wHy DIDn't YoU SAy ANYthING
            </h5>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", margin: "2rem 0" }}>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
            marginRight: "2rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/2.3.jpg"}></img>
          <div>
            <h5 style={{ color: "whitesmoke" }}>
              <br />1 year ago today, I was entering one of the darkest times of my
              life. Little did I know that in 6 short days my life would change
              forever and I would successfully make it to the other side!
            </h5>
            {/* <h6 style={{ marginLeft: "20rem", color: "whitesmoke" }}>
              ~ Brian Kiely
            </h6> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/2.4.jpg"}></img>
          <div style={{ margin: "2rem 0" }}>
            <h5 style={{ color: "whitesmoke" }}>
              Sometimes, I wish I had a better coming out story than just
              telling my dad that I like guys in the middle of a McDonald's
              drive thru during freshman year…
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingStories;
